/* NUANSE: camada de movimento e sentidos. Entrada de páginas, revelação no scroll, imagens com fade,
   peça a voar para o carrinho, toque com resposta (vibração curta no Android) e som opcional (Web Audio, sem ficheiros).
   ponytail: tudo respeita prefers-reduced-motion; o som só toca depois de um toque da pessoa e pode ser desligado. */
(function () {
  "use strict";
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var app = document.getElementById("app");
  var SK = "nz-som";
  function soundOn() { try { return localStorage.getItem(SK) !== "0"; } catch (e) { return true; } }
  var ctx = null;
  // som curto sintetizado: "tic" de joia (dois parciais altos a decair) e "acorde" para desbloqueios
  function tone(freqs, dur, vol) {
    if (!soundOn()) return;
    try {
      ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
      var t = ctx.currentTime;
      freqs.forEach(function (f, i) {
        var o = ctx.createOscillator(), g = ctx.createGain();
        o.type = "sine"; o.frequency.value = f;
        g.gain.setValueAtTime(0.0001, t + i * 0.07);
        g.gain.exponentialRampToValueAtTime(vol, t + i * 0.07 + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.07 + dur);
        o.connect(g); g.connect(ctx.destination); o.start(t + i * 0.07); o.stop(t + i * 0.07 + dur + 0.05);
      });
    } catch (e) {}
  }
  function buzz(p) { if (navigator.vibrate) try { navigator.vibrate(p); } catch (e) {} }
  window.NZFX = {
    tick: function () { tone([1760, 2637], 0.18, 0.05); buzz(10); },
    chime: function () { tone([1047, 1319, 1568, 2093], 0.5, 0.06); buzz([12, 40, 18]); },
    fly: fly
  };

  // peça a voar até ao saco
  function fly(fromImg) {
    var cart = document.querySelector(".hdr__cart");
    if (reduce || !fromImg || !cart) return;
    var a = fromImg.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width) return;
    var c = fromImg.cloneNode(); c.className = "nz-fly"; c.removeAttribute("id");
    Object.assign(c.style, { left: a.left + "px", top: a.top + "px", width: a.width + "px", height: a.height + "px" });
    document.body.appendChild(c);
    requestAnimationFrame(function () {
      c.style.transform = "translate(" + (b.left + b.width / 2 - a.left - a.width / 2) + "px," + (b.top + b.height / 2 - a.top - a.height / 2) + "px) scale(" + (28 / a.width) + ")";
      c.style.opacity = ".6";
    });
    setTimeout(function () { c.remove(); cart.classList.add("nz-bounce"); setTimeout(function () { cart.classList.remove("nz-bounce"); }, 520); }, 640);
  }

  // entrada de página + revelação no scroll + imagens com fade
  var io = "IntersectionObserver" in window && !reduce ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -8% 0px" }) : null;
  function enhance() {
    if (!reduce) { app.classList.remove("nz-enter"); void app.offsetWidth; app.classList.add("nz-enter"); }
    app.querySelectorAll(".sec, .gp, .ci, .tc > div, .fr, .faq details, .adv__col > *").forEach(function (el, i) {
      if (el.classList.contains("rv")) return;
      el.classList.add("nz-rv"); el.style.setProperty("--d", (i % 4) * 70 + "ms");
      // visível já no primeiro ecrã: nunca esconder (crawlers, Meta e capturas)
      if (io && el.getBoundingClientRect().top > innerHeight) io.observe(el); else el.classList.add("in");
    });
    // rede de segurança: nada fica invisível mais de 1,2 s (separador em segundo plano, crawlers)
    setTimeout(function () { app.querySelectorAll(".nz-rv:not(.in)").forEach(function (el) { el.classList.add("in"); }); }, 1200);
    app.querySelectorAll("img").forEach(function (im) {
      if (im.complete) return; im.classList.add("nz-img"); im.addEventListener("load", function () { im.classList.add("ok"); }, { once: true });
    });
  }
  new MutationObserver(function (m) { if (m.some(function (x) { return x.addedNodes.length; })) enhance(); }).observe(app, { childList: true });

  // resposta ao toque em botões e peças
  document.addEventListener("pointerdown", function (e) {
    var b = e.target.closest(".atc, .btn, .btn-o, .sw button, .qty button, .bundle-card, .saldo-pill");
    if (b) { b.classList.add("nz-press"); setTimeout(function () { b.classList.remove("nz-press"); }, 160); }
  }, { passive: true });
  document.addEventListener("click", function (e) {
    var b = e.target.closest("#atc, .sticky-atc .atc");
    if (b) { NZFX.tick(); fly(document.querySelector("#gal img")); }
    else if (e.target.closest(".sw button, .bundle-card")) buzz(8);
  }, true);
})();
